import {Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";

@Component({
    selector: 'transfer-documents-group',
    templateUrl: './transfer-documents-group.template.html',
    styleUrls: ['./transfer-documents-group.style.scss'],
    standalone: false
})
export class TransferDocumentsGroupComponent implements OnInit {

	private readonly SUPPORTED_FILE_EXTENSIONS: Array<string> = ['odt', 'ods', 'odp', 'ppt', 'pptx', 'doc', 'docx', 'pdf', 'csv', 'txt', 'pages', 'numbers', 'xlsx', 'xls', 'jpeg', 'jpg', 'png', 'bmp', 'raw', 'tiff'];
	private readonly MB15: number = 15000000;
	private readonly MAX_FILES_NUMBER: number = 15;

	@Input() blockInputs: boolean = false;
	@Input() groupTitle: string;
	@Input() explanationText: string;

	@ViewChild('anchor', {static:false}) anchor: ElementRef;

	fileIsTooBig: boolean;
	showFileIsRequired: boolean;
	showTooManyFiles: boolean;
	fileHasUnsupportedExtension: boolean;

	files: File[] = [];

	ngOnInit(): void {
		this.fileIsTooBig = false;
		this.showFileIsRequired = false;
		this.showTooManyFiles = false;
		this.fileHasUnsupportedExtension = false;
		this.files = [];
	}

	uploadDocuments(fileEvent: any) {
		for (const document of fileEvent.target.files) {
			let dot = document.name.lastIndexOf(".") + 1;
			let extFile = document.name.substring(dot, document.name.length).toLowerCase();
			if (!(this.SUPPORTED_FILE_EXTENSIONS.includes(extFile))) {
				this.fileHasUnsupportedExtension = true;
				return;
			}
		}

		for (const document of fileEvent.target.files) {
			if (document.size > this.MB15) {
				this.fileIsTooBig = true;
				return;
			}
		}
		for (const document of fileEvent.target.files) {
			if (this.fileIsNotDuplicated(document)) {
				this.files.push(document);
			}
		}
		this.fileIsTooBig = false;
		this.showTooManyFiles = this.files.length > this.MAX_FILES_NUMBER;
		this.showFileIsRequired = false;
		this.fileHasUnsupportedExtension = false;
		fileEvent.target.value = '';
	}

	deleteDocument(file: File) {
		if (!this.blockInputs) {
			const index = this.files.findIndex(chosenFile => chosenFile.name === file.name);
			this.files.splice(index, 1);
			this.tryRemoveTooManyFilesValidationInfo();
		}
	}

	triggerValidations() {
		this.showFileIsRequired = this.files.length === 0;
		this.showTooManyFiles = this.files.length > this.MAX_FILES_NUMBER;
	}

	isFormValid(): boolean {
		return this.files.length > 0 && this.files.length <= this.MAX_FILES_NUMBER;
	}

	areFilesUploaded(): boolean {
		return this.files.length > 0;
	}

	private fileIsNotDuplicated(file: File) {
		const index = this.files.findIndex(chosenFile => chosenFile.name === file.name);
		return index === -1;
	}

	private tryRemoveTooManyFilesValidationInfo() {
		if (this.files.length <= this.MAX_FILES_NUMBER) {
			this.showTooManyFiles = false;
		}
	}

	navigateToValidationError() {
		this.anchor.nativeElement.scrollIntoView({block: 'center', behavior: 'smooth'})
	}
}
